import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconicModule } from '../../../iconic/iconic.module';
import { ListModule } from '../../../list/list.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { QuotaInfoComponent } from './quota-info.component';
import { LoadingPanelModule } from '../../../loading-panel/loading-panel.module';
import { ChartModule } from 'app/shared/helpers/chart/chart.module';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';

@NgModule({
  imports: [
    CommonModule,
    IconicModule,
    TooltipModule,
    ScrollViewModule,
    ListModule,
    LoadingPanelModule,
    ChartModule,
    BlockModalDragModule,
  ],
  declarations: [QuotaInfoComponent],
  exports: [QuotaInfoComponent],
})
export class QuotaInfoModule {}
